import { techStatusSlice } from "@app/routes/treatmentV3/store/techStatusSlice";
import { websocketSlice } from "@app/routes/treatmentV3/store/websocketSlice";
import { videoSlice } from "@app/routes/treatmentV3/store/videoSlice";
// import { selectTreatmentId } from "@app/routes/treatmentV3/store/commonSelectorsV2";
import { treatmentServerDataSlice } from "@app/routes/treatmentV3/store/treatmentServerDataSlice";

import { relevantTreatmentV3MetricsAfterActions } from "./treatmentV3Metrics";

const metricsMW = () => store => next => action => {
  if (!window.APP_FEATURE_FLAGS.METRIC_CLIENT_LOGS) {
    return next(action);
  }

  const stateBefore = store.getState();
  const result = next(action);
  const stateAfter = store.getState();

  // const treatmentId = selectTreatmentId(stateAfter);
  [techStatusSlice.name, websocketSlice.name, videoSlice.name, treatmentServerDataSlice.name].some(word => action.type.startsWith(word))
    && relevantTreatmentV3MetricsAfterActions[action.type]?.(stateBefore, stateAfter, action);

  return result;
};
  
export default metricsMW();
